import Vue from 'vue'
import Router from 'vue-router'
import index from '@/page/Index'
import about from '@/page/About'
import game from '@/page/Game'
import contact from '@/page/Contact'
import legal from '@/page/Legal'
import careers from '@/page/Careers'
import news from '@/page/News'
Vue.use(Router)

export default new Router({
  // mode: 'history',
  routes: [{
      path: '/', // 重定向地址
      redirect: '/index'
    },
    {
      path: '/index',
      name: 'index',
      component: index
    },
    {
      path: '/about',
      name: 'about',
      component: about
    },
    {
      path: '/game',
      name: 'game',
      component: game
    },
    {
      path: '/contact',
      name: 'contact',
      component: contact
    },
    {
      path: '/legal',
      name: 'legal',
      component: legal
    },
    {
      path: '/careers',
      name: 'careers',
      component: careers
    },
    {
      path: '/news',
      name: 'news',
      component: news
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js